import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { GO_MAIN } from '@pages/MatchingFail/focuskey';
import constate from 'constate';
import { useNavigate } from 'react-router-dom';
import { ROOT } from '@router/path';

const useMatchingFail = () => {
  const { setFocus } = useFocusable();

  const navigate = useNavigate();

  const setButtonFocus = () => {
    setFocus(GO_MAIN);
  };

  const goMain = () => {
    navigate(ROOT);
  };

  return { setButtonFocus, goMain };
};

export const [MatchingFailProvider, useMatchingFailContext] = constate(useMatchingFail);
